import apiServiceNew from './apiService.new';

export default (function () {

	const servicePath = 'MediaContentLibrary/Search';

	function Search(section, params, proxiedAsUserId) {
		params['section_id'] = section.id;

		return apiServiceNew.get(servicePath, {
			params: {
				...params,
				proxiedAsUserId: proxiedAsUserId,
			}
		});
	}

	return {
		Search: Search,
	};
})();